<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-05 10:34:36
 * @Description: 重大事项公布
 -->

<template>
  <div class="important-event-wrapper">
    <img src="https://files.jinr.com/jinr-index/img/important-event-01.png" alt="" srcset="" />
    <img src="https://files.jinr.com/jinr-index/img/important-event-02.png" alt="" srcset="" />
    <router-link class="btn" to="/m-information/m-organizetion"></router-link>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.important-event-wrapper {
  position: relative;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .btn {
    display: block;
    position: absolute;
    width: 100%;
    height: 0.62rem;
    bottom: 0;
    left: 0;
  }
}
</style>
